import { useCallback, useEffect, useState } from "react"

import { Flex, Skeleton, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { selectKpi } from "../../redux/receipt.slice"
import { buildKpiCards } from "./kpiCards"

import styles from "./styles.module.less"

const { Text, Title } = Typography

// §BLOCK 2 — 3 non-interactive cards, respond to program selector (see ./kpiCards.js).

export const KpiCards = ({ getReceiptKpi, isDemo, isActive }) => {
  const { t } = useTranslation()
  const kpi = useSelector(selectKpi)
  const [loading, setLoading] = useState(false)

  const cards = buildKpiCards(kpi)

  const handleGetReceiptKpi = useCallback(async () => {
    try {
      setLoading(true)
      await getReceiptKpi()
    } finally {
      setLoading(false)
    }
  }, [getReceiptKpi])

  useEffect(() => {
    if (isActive || isDemo) void handleGetReceiptKpi()
  }, [handleGetReceiptKpi, isActive, isDemo])

  return (
    <Flex gap={16} className={styles.grid}>
      {loading
        ? Array.from({ length: cards.length }, (_, i) => (
            <Flex key={i} vertical gap={8} className={styles.card}>
              <Skeleton.Node active className={styles.skeletonLabel} />
              <Skeleton.Node active className={styles.skeletonValue} />
              <Skeleton.Node active className={styles.skeletonSubtitle} />
            </Flex>
          ))
        : cards.map((c) => (
            <Flex
              key={c.key}
              vertical
              gap={4}
              align="start"
              className={styles.card}
              data-testid={`deflect-user-kpi-${c.key}`}
            >
              <Text
                ellipsis={{ tooltip: t(c?.label) }}
                type="secondary"
                strong
                style={{ fontSize: 14 }}
              >
                {t(c.label)}
              </Text>
              <Title
                ellipsis={{ tooltip: c.value }}
                level={3}
                style={{
                  margin: 0,
                  fontSize: 28,
                  fontWeight: 600,
                  width: "100%",
                  textAlign: "start"
                }}
              >
                {c.value}
              </Title>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {t(c.subtitle)}
              </Text>
            </Flex>
          ))}
    </Flex>
  )
}
